import React from 'react';

import { AsyncBoundary } from 'utils/asyncBoundary/asyncBoundaryTypes';
import { AsyncBoundaryContext } from 'utils/asyncBoundary/asyncBoundaryUtils';

export const useAsyncBoundary = (): AsyncBoundary => {
  return React.useContext(AsyncBoundaryContext);
};
